import { QrCodeIcon } from "@phosphor-icons/react/dist/csr/QrCode";
import { useMemo } from "react";
import { AttributionBadge } from "@/core/components/attribution-badge";
import { AutomationBadge } from "@/core/components/automation-badge";
import { SelfSignupBadge } from "@/core/components/self-signup-badge";
import { Skeleton } from "@volca/ui/components/ui/skeleton";
import type { SignupSource } from "@/referral-sources/referral-source";

interface TextMessageAttributionProps {
  signupSource?: SignupSource | null;
  messageBody: string;
  isLoading?: boolean;
}

export const TextMessageAttribution: React.FC<TextMessageAttributionProps> = ({
  signupSource,
  messageBody,
  isLoading = false,
}) => {
  const badgeType = useMemo(() => {
    if (isLoading) {
      return null;
    }
    if (signupSource) {
      return "attribution";
    }
    if (messageBody.toLowerCase().startsWith("referral")) {
      return "self-signup";
    }
    return "automation";
  }, [isLoading, signupSource, messageBody]);

  if (isLoading) {
    return <Skeleton className="h-6 w-20" />;
  }

  if (badgeType === "attribution" && signupSource) {
    return (
      <AttributionBadge
        icon={<QrCodeIcon className="h-4 w-4" />}
        signupSource={signupSource}
        section="text-messages"
      />
    );
  }

  if (badgeType === "self-signup") {
    return <SelfSignupBadge />;
  }

  if (badgeType === "automation") {
    return <AutomationBadge />;
  }

  return null;
};

TextMessageAttribution.displayName = "TextMessageAttribution";
